var map = {
	"./01_thumbnail.jpg": 385,
	"./02_thumbnail.jpg": 386,
	"./03_thumbnail.jpg": 387,
	"./04_thumbnail.jpg": 388,
	"./07_thumbnail.jpg": 389,
	"./2ATH3BK.crop.jpg": 390,
	"./ABENT3.crop_thumb.jpg": 391,
	"./Around-img-1.jpg": 392,
	"./Around-img-1@2x.jpg": 393,
	"./Crater17-Chuvilin.jpg": 394,
	"./Footer-Desktop.jpg": 395,
	"./Footer-Mobile.jpg": 396,
	"./Footer-Tablet.jpg": 397,
	"./GettyImages-1229380660_thumbnail.jpg": 398,
	"./GettyImages-683364764_crop.jpg": 399,
	"./James-wong-article-thumbnail.jpg": 400,
	"./James-wong-thumbnail.jpg": 401,
	"./LNC-aggregates-on-sand-2-crop.jpg": 402,
	"./Mountain_pines_Uttarakhand_cred_Alamy.jpg": 403,
	"./Opt_out_bell.svg": 404,
	"./Opt_out_message.svg": 405,
	"./Seawatergreenhouseaus_crop.jpg": 406,
	"./The_miller_delivering_flour_to_people_homes.jpg": 407,
	"./Thought-leaders-thumbnail.jpg": 408,
	"./Water_hyacinth_GettyImages-170500069.jpg": 409,
	"./about-icon.png": 410,
	"./add-to-home.png": 411,
	"./add-to-home.svg": 412,
	"./aerial.jpg": 413,
	"./africa_getty.jpg": 414,
	"./arrow_icon.svg": 415,
	"./arrow_right.svg": 416,
	"./bbc-logo.png": 417,
	"./bbc-storyworks-logo.png": 418,
	"./bug.jpg": 419,
	"./cattle-drones-thumbnail.jpg": 420,
	"./cityFarms.jpg": 421,
	"./client-logo-white-02.svg": 422,
	"./client-logo.png": 423,
	"./client-logo.svg": 424,
	"./client-logo2.png": 425,
	"./coffee.jpg": 426,
	"./crops.png": 427,
	"./external_1.jpg": 428,
	"./external_2.jpg": 429,
	"./external_3.jpg": 430,
	"./external_4.jpg": 431,
	"./farmer.jpg": 432,
	"./farming-in-forests-article.jpg": 433,
	"./farms.png": 434,
	"./food-chain-thumbnail-article.jpg": 435,
	"./hero_getty.jpg": 436,
	"./how-covid-19-is-changing-food-shopping.jpg": 437,
	"./how-we-can-adapt-plants-to-save-our-planet-thumbnail.jpg": 438,
	"./how_algae_could_transform_diets_article.jpg": 439,
	"./kiwi-picker-robotics.jpg": 440,
	"./leftArrow.svg": 441,
	"./mineral.png": 442,
	"./miracles_in_a_crisis.jpg": 443,
	"./opt-in-bar.svg": 444,
	"./plastic-problem-article.jpg": 445,
	"./rightArrow.svg": 446,
	"./rooftop.jpg": 447,
	"./save_the_bees_article.jpg": 448,
	"./the-fisherman-selling-his-catch-on-social-media.jpg": 449,
	"./the-freedom-soup-saving-a-city.jpg": 450,
	"./the-green-milk-made-from-cells.jpg": 451,
	"./the-massive-farms-emerging-beneath-our-cities.jpg": 452,
	"./the-simple-shellfish-that-fights-climate-change-thumbnail.jpg": 453,
	"./the-urban-farm-sending-meals-to-children.jpg": 454,
	"./the_invisible_women_article.jpg": 455,
	"./update-bar.svg": 456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;